<template>
    <el-form label-width="150px" label-position="left">
        <el-row>
            <el-col :span="6">
                <el-form-item label="成本计费前置：">
                    <span @dblclick="copyItem($event)">{{formData.billingCostAdvanceFlag || '--'}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="收入计费前置：">
                    <span @dblclick="copyItem($event)">{{formData.billingIncomeAdvanceFlag || '--'}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="会计主体：">
                    <el-tooltip class="item" effect="dark" :content="formData.invoiceUnitName || '--'" placement="top">
                        <span @dblclick="copyItem($event)">{{formData.invoiceUnitName || '--'}}</span>
                    </el-tooltip>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="计费业务类型：">
                    <span @dblclick="copyItem($event)">{{formData.businessTypeName || '--'}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="运费类型：">
                    <span @dblclick="copyItem($event)">{{formData.deliverypayType || '--'}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="是否代收货款：">
                    <span @dblclick="copyItem($event)">{{formData.collectionFlag || '--'}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="代收货款金额：">
                    <span @dblclick="copyItem($event)">{{formateData(formData.collectionAmount)}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="回收金额：">
                    <span @dblclick="copyItem($event)">{{formateData(formData.receivedSumCount)}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="代收货款方式：">
                    <span @dblclick="copyItem($event)">{{formData.paymentType || '--'}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="退货单号：">
                    <span @dblclick="copyItem($event)">{{formData.returnOrderNo || '--'}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="调整前代收款金额：">
                    <span @dblclick="copyItem($event)">{{formateData(formData.frontAmountCollected)}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="调整后代收款金额：">
                    <span @dblclick="copyItem($event)">{{formateData(formData.laterAmountCollected)}}</span>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
import { copyToClip } from '../util.js';
export default {
    name: 'CollectionInformation',
    props: {
        formData: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    computed: {
        formateData() {
            return function (data) {
                if (data === null || data === undefined || data === '') {
                    return '--';
                } else {
                    return data;
                }
            };
        }
    },
    methods: {
        copyItem (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && copyToClip(value);
        }
    }
};
</script>
